"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgChar = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const FormRow_1 = require("../../../../3-list-item/FormRow");
const InputChar_1 = require("../../../../2-inline-block/InputChar");
const css_1 = require("./css");
const ArgCharCompact_1 = require("./ArgCharCompact");
const unwrap = (v) => {
    if (v && typeof v === 'object' && 'value' in v)
        return String(v.value ?? '');
    return v ?? '';
};
const ArgChar = (props) => {
    if (props.compact)
        return React.createElement(ArgCharCompact_1.ArgCharCompact, { ...props });
    const { param, value, onChange, focus } = props;
    const defaultable = !!param.defaultable;
    return (React.createElement("div", { className: css_1.argBlockCss },
        React.createElement(FormRow_1.FormRow, { title: param.display?.() ?? param.name ?? param.id, optional: param.optional },
            React.createElement(InputChar_1.InputChar, { value: unwrap(value), placeholder: param.placeholder, focus: focus, emoji: param.emoji, onChange: (v) => (defaultable ? onChange({ def: false, value: v }) : onChange(v)) }))));
};
exports.ArgChar = ArgChar;
